import React, { useEffect } from 'react';
import { 
    SimpleFormIterator, 
    Create,
    Datagrid,
    TextField,
    SimpleForm,
    ImageField,
    TextInput,
    ArrayInput,
    ImageInput,
    TopToolbar,
    CreateButton,
    FormDataConsumer,
    NumberInput,
    useRecordContext,
    useUpdate,
    RecordContextProvider,
    ArrayField,
    useShowContext,
    useShowController,
    SimpleShowLayout,
    SaveButton,
    useGetOne,
    useDataProvider,
    useNotify
    } from 'react-admin';
import MaterialButton from '@mui/material/Button';
import { Card } from "@mui/material";

export const ThumbnailsCreate = () => (
    <Create redirect="edit">
      <SimpleForm>
        <TextInput source="videoId" label="Video Id" />
        <ImageInput source="images" label="Images" accept="image/*" maxSize={2000000} multiple>
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  )

  export const ThumbnailsShow = ({videoId}) => {
    const videoRecord = useShowContext()
    const {isLoading,record, error} = useShowController({ resource: 'thumbnails', id: videoId})
    if (isLoading) {
        return <div>Loading Thumbnails...</div>;
    }
    if (error) {
        return <div>Error loading Thumbnails!</div>;
    }
    return (
        <RecordContextProvider value={record}>
            <h4>Thumbnails</h4>
            <TopToolbar>
                <CreateButton />
            </TopToolbar>
            <SimpleShowLayout>
                <ArrayField source="data" label=''>
                    <Datagrid bulkActionButtons={false}>
                        <ImageField source="url" label="" />
                        <IsActive />
                        <TextField source="ctr"  />
                    </Datagrid>
                </ArrayField>
            </SimpleShowLayout>
        </RecordContextProvider>
    );
}

  export const ThumbnailsEdit = ({id,videoId}) =>{ 
    const {data, loading, error} = useGetOne('thumbnails', {id:videoId})
    const dataProvider = useDataProvider();
    const[isupdating, setIsUpdating] = React.useState(false)
    const notify = useNotify();
    const handleSave = (data) => {
        (async () => {
            setIsUpdating(true)
            await dataProvider.update('thumbnails', {id:videoId, data: data})
            notify("Thumbnails updated")
            setIsUpdating(false)
            window.location.reload(true)
        })()
    }
    if (loading || isupdating) return <div>Loading...</div>;
    return (
    <Card>
        <h4>Thumbnails</h4>
    <SimpleForm record={data} toolbar={<Toolbar/>} onSubmit={handleSave}>
        <ArrayInput source="data" label = "Priority" >
               <SimpleFormIterator disableAdd inline >
                <FormDataConsumer >
                    {({ scopedFormData,getSource }) => (  
                    <div style={scopedFormData.active === 1 ? {backgroundColor:"#abf7b1"} : {backgroundColor:"transparent"}}>
                        {scopedFormData.active === 1 ? <b style={{margin:"5px"}}>Active Thumbnail</b>
                        : <SetActiveButton priority ={scopedFormData.priority}  />}
                        <ImageField source="url" record={scopedFormData} /> 
                        <NumberInput sx={{margin:"5px"}} source={getSource('ctr')} label="CTR" disabled />
                        <TextInput sx={{margin:"5px"}} source={getSource('activationDate')} label="Date Activated" disabled />
                        <TextInput sx={{margin:"5px"}} source={getSource('deactivationDate')} label="Date Deactivated" disabled />
                    </div>                      
                    )}  
                </FormDataConsumer>
               </SimpleFormIterator>
        </ArrayInput>
        <ImageInput source="images" label="Images" accept="image/*" maxSize={2000000} multiple>
          <ImageField source="src" title="title" />
        </ImageInput>
    </SimpleForm>
  </Card>
  )
  }

  const Toolbar = () => (<TopToolbar><SaveButton /></TopToolbar>)

  const IsActive = () => {
    const record = useRecordContext();
    if(!record) return null;
    if(record.active) return ( <b style={{color:"green"}}>Active Thumbnail</b>)
    return <></>
  }
  const SetActiveButton = ({priority}) => {
    const record = useRecordContext();
    const [update, { isLoading, error }] = useUpdate();
    const handleClick = () => {
        if(record){
            let newRecord = {...record};
            newRecord.data.forEach(element => {
                if(element.active === 1){
                    element.deactivationDate = new Date().toISOString().replace('T', ' ').replace('Z', '')
                }
                element.active = 0;
            });
            newRecord.data[priority-1].active = 1;
            newRecord.data[priority-1].activationDate = new Date().toISOString().replace('T', ' ').replace('Z', '')
            newRecord.data[priority-1].deactivationDate = ""
            console.log(newRecord)
            update('thumbnails', {id:record.id, data:newRecord, previousData:record});
        }
    }
    if(!record || !priority) return null;
    return (
        <MaterialButton disabled={isLoading} onClick ={handleClick}>Set Active</MaterialButton>
    )
  }